import { render, staticRenderFns } from "./ProductImageSlider.vue?vue&type=template&id=13542cf8&"
import script from "./ProductImageSlider.vue?vue&type=script&lang=js&"
export * from "./ProductImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports